import { render, staticRenderFns } from "./BulkSendFailedEntries.vue?vue&type=template&id=79d0107c&scoped=true&lang=pug"
import script from "./BulkSendFailedEntries.vue?vue&type=script&lang=js"
export * from "./BulkSendFailedEntries.vue?vue&type=script&lang=js"
import style0 from "./BulkSendFailedEntries.vue?vue&type=style&index=0&id=79d0107c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d0107c",
  null
  
)

export default component.exports